import React from "react";


const Homeworks = () => {


    return (
        <p className="text-sm leading-normal text-gray-600">
            Homewoks
        </p>
    )
}

export default Homeworks